import { FC, SVGProps } from 'react';

interface ICircleCheckOutlinedProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const CircleCheckOutlined: FC<ICircleCheckOutlinedProps> = ({
  color = '#03AB5A',
  ...props
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99967 18.9163C5.08099 18.9163 1.08301 14.9183 1.08301 9.99963C1.08301 5.08097 5.08099 1.08301 9.99967 1.08301C14.9184 1.08301 18.9163 5.08097 18.9163 9.99963C18.9163 14.9183 14.9184 18.9163 9.99967 18.9163ZM9.99967 2.32719C5.76944 2.32719 2.32719 5.76942 2.32719 9.99963C2.32719 14.2298 5.76944 17.6721 9.99967 17.6721C14.2299 17.6721 17.6722 14.2298 17.6722 9.99963C17.6722 5.76942 14.2299 2.32719 9.99967 2.32719Z"
      fill={color}
    />
    <path
      d="M8.82192 12.9695C8.65603 12.9695 8.49843 12.9032 8.38231 12.787L6.0349 10.4397C5.79436 10.1991 5.79436 9.80101 6.0349 9.56047C6.27544 9.31993 6.67358 9.31993 6.91412 9.56047L8.82192 11.4682L13.0853 7.20482C13.3259 6.96428 13.724 6.96428 13.9646 7.20482C14.2051 7.44536 14.2051 7.8435 13.9646 8.08404L9.26153 12.787C9.14541 12.9032 8.98781 12.9695 8.82192 12.9695Z"
      fill={color}
    />
  </svg>
);

export default CircleCheckOutlined;
